import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7289cbb4")

_pushScopeId("data-v-7289cbb4")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "btns_container" }
const _hoisted_3 = { class: "canvas_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeModal()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.arrowBackOutline,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _createTextVNode("Firma " + _toDisplayString($setup.reference), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", {
                class: "btn_red",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.clearCanvas && $setup.clearCanvas(...args)))
              }, "Pulisci firma"),
              _createVNode("div", {
                class: "btn_green",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.confermaFirme && $setup.confermaFirme(...args)))
              }, "Conferma firma")
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("canvas", {
                ref: "canvas",
                onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.mStart && $setup.mStart(...args))),
                onTouchmove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.mMove && $setup.mMove(...args))),
                onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.mEnd && $setup.mEnd(...args)))
              }, null, 544)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})